import React, { useState } from "react";
import "./CSS/VideoSection.css";
import banner from "./IMAGES/Video Image → LM0j0bLrzJ2LqVyhFi6uJX8iU.png.png"; 

const VideoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);

  return (
    <div className="video-section">
      <div className="video-container">
        <img src={banner} alt="video preview" className="video-image" />

        {!isPlaying && (
          <button
            className="play-btn"
            onClick={() => setIsPlaying(true)}
          >
            ▶
          </button>
        )}

        {isPlaying && (
          <div className="fake-video">
            <p>▶ Playing Demo Video...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoSection;